import { Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { useSubscription } from "@/hooks/useSubscription";

const Footer = () => {
  const { t } = useLanguage();
  const { prices } = useSubscription();

  return (
    <footer className="border-t border-border bg-card/50 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="space-y-4">
            <p className="text-lg font-semibold text-foreground">Taskeer</p>
            <p className="text-sm text-muted-foreground">
              {t('footer.about')}
            </p>
          </div>

          <div className="space-y-4">
            <p className="text-lg font-semibold text-foreground">{t('footer.quickLinks')}</p>
            <ul className="space-y-2">
              <li>
                <Link to="/auth" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  {t('footer.enter')}
                </Link>
              </li>
              <li>
                <Link to="/auth" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  {t('footer.createAccount')}
                </Link>
              </li>
              <li>
                <a href="#pricing" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  {t('footer.plans')}
                </a>
              </li>
              <li>
                <Link to="/ferramentas" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Ferramentas grátis
                </Link>
              </li>
              <li>
                <Link to="/ferramentas/gerador-qr-code-pix" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gerador de QR Code PIX
                </Link>
              </li>
              <li>
                <Link to="/ferramentas/calculadora-preco-hora-freelancer" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Calculadora de preço por hora
                </Link>
              </li>
              <li>
                <Link to="/ferramentas/gerador-de-orcamento" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gerador de orçamento
                </Link>
              </li>
              <li>
                <Link to="/ferramentas/gerador-de-contrato" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gerador de contrato
                </Link>
              </li>
              <li>
                <Link to="/ferramentas/gerador-de-recibo" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gerador de recibo
                </Link>
              </li>
              <li>
                <Link to="/ferramentas/calculadora-limite-mei" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Limite de faturamento MEI
                </Link>
              </li>
              <li>
                <Link to="/alternativas" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Comparativos
                </Link>
              </li>
            </ul>
          </div>


          <div className="space-y-4">
            <p className="text-lg font-semibold text-foreground">{t('footer.plans')}</p>
            <ul className="space-y-2">
              <li className="text-sm text-muted-foreground">
                Prime - {prices.prime.formatted}/{t('pricing.month')}
              </li>
              <li className="text-sm text-muted-foreground">
                PRO - {prices.pro.formatted}/{t('pricing.month')}
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <p className="text-lg font-semibold text-foreground">{t('footer.contact')}</p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <Mail className="w-4 h-4" />
                contato@oskargroup.net
              </li>
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <Phone className="w-4 h-4" />
                +55 41 99879-2155
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <p className="text-center text-sm text-muted-foreground">
            © 2026 Taskeer by Oskar Group. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
